var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20","height":"20","viewport":"0 0 20 20"}},[_c('path',{attrs:{"d":"M0 4 L0 12 L6.928203230275509 16 L13.856406460551018 12 L13.856406460551018 4 L6.928203230275509 0 z","fill":_vm.color,"stroke-width":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }